import { render, staticRenderFns } from "./DetalhesOperador.vue?vue&type=template&id=12493576"
import script from "./DetalhesOperador.vue?vue&type=script&lang=js"
export * from "./DetalhesOperador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports